import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl } from "../../helper/urls.js";
import { useSelector } from "react-redux";

const BookingTable = () => {
  const url = `${baseUrl}/bookings`;
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  const bookingData = location.state?.booking;
  const navigate = useNavigate();
  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // "YYYY-MM-DD"
  };

  const [formData, setFormData] = useState({
    student_id: "",
    counselor_id: "",
    slot_id: "",
    booking_date: getTodayDate(),
    booking_time: getCurrentTime(),
    booking_duration: "",
    status: 0,
  });

  useEffect(() => {
    if (bookingData) {
      fetchSlots(bookingData.counselor_id);
      setFormData(bookingData);
    }
  }, [bookingData]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "counselor_id") {
      await fetchSlots(value); // Await the fetchSlots call
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        slot_id: "", //reset slot id
      }));
    } else if (name === "slot_id") {
      const selectedSlot = slots.find(
        (slot) => slot.id === parseInt(value, 10)
      ); // Find selected slot
      if (selectedSlot) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
          booking_date: selectedSlot.date.split("T")[0],
          booking_time: selectedSlot.start_time,
          booking_duration: selectedSlot.duration, // Extract date
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      let response;
      if (bookingData?.id) {
        // Update booking
        response = await axios.patch(
          `${url}/${bookingData.id}/${bookingData.status}`,
          formData,
          {
            headers,
          }
        );
      } else {
        // Create new booking
        response = await axios.post(url, formData, { headers });
      }

      if (response.status === 201) {
        toast.success("Booking saved successfully!");
        navigate("/all-booking");
      }
    } catch (error) {
      console.error("Booking error:", error);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong!"
      );
    }
  };
  const url1 = `${baseUrl}/api/students`;
  const token1 = sessionStorage.getItem("token");
  const [students, setStudents] = useState([]);

  const fetchStudents = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token1}`,
      };

      const response = await axios.get(url1, { headers });
      // console.log("response::::::::::::::::::::", response);

      setStudents(response.data.data || []);
    } catch (error) {
      console.log("error::::::::::::::::::::::::::", error);
    }
  };

  const [counselors, setCounselors] = useState([]);

  const fetchCounselors = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/counselors/approved`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setCounselors(response.data.data);
    } catch (error) {
      console.log("error::::::::::::::::::::::", error);
    }
  };

  const [slots, setSlots] = useState([]);

  const fetchSlots = async (counselor_id) => {
    try {
      const response = await axios.get(
        `${baseUrl}/slots/counselor/${counselor_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("error::::::::::::::::::::::::::", response.data);
      setSlots(response.data);
    } catch (error) {
      console.log("Error fetching slots:", error);
    }
  };

  useEffect(() => {
    fetchStudents();
    fetchCounselors();
  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="card h-100 p-0 radius-12">
        <div className="row justify-content-center">
          <div className="col-xxl-12 col-xl-12 col-lg-12">
            <div className="card border">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Student <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control radius-8"
                        name="student_id"
                        value={formData.student_id}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Student</option>
                        {students?.map((stu) => (
                          <option key={stu.id} value={stu.id}>
                            {stu.firstName} {stu.lastName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Counselor <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control radius-8"
                        name="counselor_id"
                        value={formData.counselor_id}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Counselor</option>
                        {counselors?.map((counselor) => (
                          <option key={counselor.id} value={counselor.id}>
                            {counselor.firstName} {counselor.lastName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Slot ID <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control radius-8"
                        name="slot_id"
                        value={formData.slot_id}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Slot</option>
                        {slots?.map((slot) => (
                          <option key={slot.id} value={slot.id}>
                            {/* {slot.id} -{" "} */}
                            {slot.date.split("T")[0]} | {slot.start_time} →{" "}
                            {slot.end_time}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Booking Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control radius-8"
                        name="booking_date"
                        value={formData.booking_date}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Booking Time <span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        className="form-control radius-8"
                        name="booking_time"
                        value={formData.booking_time}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Duration (minutes){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control radius-8"
                        name="booking_duration"
                        value={formData.booking_duration}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>
                    {/* <div className="col-sm-6 mb-20">
                      <label className="form-label">
                        Status{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control radius-8"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                  </div>

                  <div className="d-flex justify-content-end gap-3 mt-4">
                    {/* <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => navigate("/all-booking")}
                    >
                      Cancel
                    </button> */}
                    <button type="submit" className="btn btn-primary">
                      {bookingData ? "Update" : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingTable;
